import dashboardSlice from '../../src/views/Dashboard/Tab/Dashboard1/stores';
import dashboardAttendanceSlice from '../../src/views/Dashboard/Tab/Dashboard2/store/index';
import holidaySlice from '../views/Master/HolidayMaster/store/index';
import locationSlice from '../views/Location/store';
import allowanceSlice from '../../src/views/Master/Allowance/store/index';
import faqCategorySlice from '../../src/views/Master/FaqCategory/store/index';
import taskTypeSlice from '../../src/views/Master/TaskType/store/index';
import reactionSlice from '../../src/views/Master/Reaction/store/index';
import taskStateSlice from '../../src/views/Master/TaskState/store/index';
import labelSlice from '../../src/views/Master/Label/store/index';
import faqSlice from '../../src/views/Help/AddFaq/store/index';
import deductionSlice from '../../src/views/Master/Deduction/store/index';
import leaveCategorySlice from '../views/Master/LeaveCategoryMaster/store/index';
import shiftSlice from '../../src/views/Master/Shift/store/index';
import gradeSlice from '../../src/views/EmployeeMaster/Grade/store/index';
import designationSlice from '../../src/views/EmployeeMaster/Designation/store/index';
import branchSlice from '../views/CompanyMaster/Branch/store/index';
import departmentSlice from '../../src/views/EmployeeMaster/Department/store/index';
import employeetypeSlice from '../../src/views/EmployeeMaster/Type/store/index';
import myProfileSlice from '../views/MyProfile/store';
import userSlice from '../../src/views/Setup/User/store/index';
import roleSlice from '../../src/views/Setup/RoleRights/Role/store/index';
import employeeSlice from '../views/EmployeeMaster/store';
import deviceSlice from '../views/Biometric/Device/store/index';
import kycDocumentSlice from '../views/CompanyMaster/KycDocument/store/index';
import attendanceSlice from '../views/Attendance/store';
import auditLogSlice from '../views/AuditLog/Tabs/AuditLog/store/index';
import auditLog2Slice from '../views/AuditLog2/Tabs/AuditLog/store/index';
import loginLogSlice from '../views/AuditLog/Tabs/LoginLog/store/index';
import shiftChangeSlice from '../../src/views/Hr/Requests/Tabs/ShiftChange/store/index';
import attendanceCorrectionSlice from '../views/Hr/Requests/Tabs/Correction/store/index';
import regularizationSlice from '../views/Hr/Requests/Tabs/Regularization/store/index';
import leaveSlice from '../views/Hr/Requests/Tabs/Leave/store/index';
import requestRemarksSlice from '../views/Hr/Requests/Tabs/store';
import LeaveRuleSlice from '../views/CompanyMaster/LeaveRules/store/index';
import OverTimeSlice from '../views/Hr/Requests/Tabs/OverTime/store/index';
import CompOffSlice from '../views/Hr/Requests/Tabs/CompOff/store/index';
import activeClosedSlice from '../views/Help/HelpDesk/store/index';
import ytdReportSlice from '../views/Salary/YtdReport/store/index';
import moduleSlice from '../views/ModuleManage/store/index';
import incomeCategorySlice from '../views/Master/IncomeCategory/store';
import consolidationSlice from '../../src/views/Salary/Consolidation/store/index';
import salarySlipSlice from '../views/Salary/SalarySlip/store/index';
import performanceSlice from '../views/Reports/Performance/Store/index';
// import dashboard from '../views/Dashboard/NewStore';
import dayAdjustment from '../views/Master/DayAdjustment/store/index';
import payableSlice from '../views/Salary/Payable/store/index';
import assetSlice from '../views/Assets1/store/index';
import resignationSlice from '../views/EmployeeTransitions/Resignation/store/index';
import terminationSlice from '../views/EmployeeTransitions/Termination/store/index';
import promotionSlice from '../views/EmployeeTransitions/Promotion/store/index';
import screenCaptureSlice from '../views/ScreenTracker/Tabs/ScreenCapture/store/index';
import inputMonitorSlice from '../views/ScreenTracker/Tabs/InputMonitor/store/index';
import deviceUsageSlice from '../views/ScreenTracker/Tabs/DeviceUsage/store/index';
import appTimeTrackSlice from '../views/ScreenTracker/Tabs/AppTimeTracker/store/index';
import inactiveIntervalSlice from '../views/ScreenTracker/Tabs/InactiveInterval/store/index';
import feedsSlice from '../views/Feeds/store/index';
import appCalendarSlice from '../views/calendar/store/index';
import remainderCalendarSlice from '../views/calendar/store/NewStore';
import manualAttendanceSlice from '../views/ManualAttendance/Store/index';
import multiProfileSlice from '../views/Authentication/store/index';
import incrementRequestSlice from '../views/Salary/IncrementRequest/store';
import projectSlice from '../views/Project/store/index';
import reportingSlice from '../views/Reporting/store/index';
import projectRoleSlice from '../views/ProjectRole/store/index';
import yourProjectSlice from '../views/YourProject/store/index';
import expenseSlice from '../../src/views/Master/ExpenseCategory/store/index';
import expensesSlice from '../../src/views/Expense/store/index';
import taskStateAndTypeSlice from '../views/Project/Tabs/StateAndType/store/index';
import salaryRuleSlice  from '../views/Rules/SalaryRules/store';
import geoLocationSlice  from '../views/Rules/GeoLocation/store';
import weekendSettingSlice  from '../views/Rules/WeekendPolicy/store';
import attendancePolicySlice  from '../views/Rules/AttendanceRules/store';
import jobSchedulerSliceData from '../views/Scheduler/JobScheduler/store';
import jobExecutionSlice from '../views/Scheduler/JobExecution/store';
import rulesLeaveRuleSlice  from '../views/Rules/LeaveRules/store';
import leaveRuleSlice  from '../views/Rules/LeaveRules/store';
import encashmentSlice  from '../views/Hr/Requests/Tabs/Encashment/store';
import companySlice from '../views/CompanyMaster/Company/store/index';
import ODRemoteWorkSlice from '../views/Rules/ODRemoteWork/store/index';
import inboxCorrectionSlice from '../views/Hr/Inbox/Tabs/Correction/store';
import inboxLeaveSlice from '../views/Hr/Inbox/Tabs/Leave/store';
import inboxEncashmentSlice from '../views/Hr/Inbox/Tabs/Encashment/store';
import inboxRegularizationSlice from '../views/Hr/Inbox/Tabs/Regularization/store';
import inboxShiftChangeSlice from '../views/Hr/Inbox/Tabs/ShiftChange/store';
import inboxOverTimeSlice from '../views/Hr/Inbox/Tabs/OverTime/store';
import inboxCompOffSlice from '../views/Hr/Inbox/Tabs/CompOff/store';


const crudApis = {
    dashboardSlice,
    dashboardAttendanceSlice,
    holidaySlice,
    locationSlice,
    allowanceSlice,
    faqCategorySlice,
    faqSlice,
    deductionSlice,
    leaveCategorySlice,
    shiftSlice,
    gradeSlice,
    designationSlice,
    branchSlice,
    auditLog2Slice,
    departmentSlice,
    employeetypeSlice,
    myProfileSlice,
    userSlice,
    roleSlice,
    employeeSlice,
    deviceSlice,
    kycDocumentSlice,
    attendanceSlice,
    shiftChangeSlice,
    activeClosedSlice,
    ytdReportSlice,
    payableSlice,
    attendanceCorrectionSlice,
    regularizationSlice,
    leaveSlice,
    requestRemarksSlice,
    LeaveRuleSlice,
    OverTimeSlice,
    CompOffSlice,
    moduleSlice,
    auditLogSlice,
    incomeCategorySlice,
    consolidationSlice,
    salarySlipSlice,
    loginLogSlice,
    // dashboard,
    dayAdjustment,
    performanceSlice,
    assetSlice,
    resignationSlice,
    terminationSlice,
    promotionSlice,
    screenCaptureSlice,
    inputMonitorSlice,
    deviceUsageSlice,
    appTimeTrackSlice,
    inactiveIntervalSlice,
    feedsSlice,
    appCalendarSlice,
    remainderCalendarSlice,
    manualAttendanceSlice,
    multiProfileSlice,
    incrementRequestSlice,
    projectSlice,
    reportingSlice,
    projectRoleSlice,
    yourProjectSlice,
    taskTypeSlice,
    labelSlice,
    reactionSlice,
    taskStateSlice,
    expenseSlice,
    expensesSlice,
    taskStateAndTypeSlice,
    salaryRuleSlice,
    geoLocationSlice,
    weekendSettingSlice,
    attendancePolicySlice,
    jobSchedulerSliceData,
    jobExecutionSlice,
    rulesLeaveRuleSlice,
    leaveRuleSlice,
    encashmentSlice,
    companySlice,
    ODRemoteWorkSlice,
    inboxCorrectionSlice,
    inboxLeaveSlice,
    inboxEncashmentSlice,
    inboxRegularizationSlice,
    inboxShiftChangeSlice,
    inboxOverTimeSlice,
    inboxCompOffSlice
};

export default crudApis;
